import React, { useContext } from 'react';
import ThemeContext from '../../context/theme/themeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const themeContext = useContext(ThemeContext);
  const { isDarkMode, toggleTheme } = themeContext;

  return (
    <div className="theme-toggle-container">
      <button 
        className="theme-toggle-btn" 
        onClick={toggleTheme}
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDarkMode ? (
          <i className="fas fa-sun" /> // Sun icon for dark mode (to switch to light)
        ) : (
          <i className="fas fa-moon" /> // Moon icon for light mode (to switch to dark)
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;